/**
 "avatar": "https://dev.azure.com/drsutphin/_api/_common/identityImage?id=0454ff85-a1d9-6f85-bec9-13a5a3181470",
 "displayName": "Samuel Wilemon",
 "id": "0454ff85-a1d9-6f85-bec9-13a5a3181470",
 "emailAddress": "samuel.wilemon@fedex.com"
 */

export interface TeamMember {
  avatar: string;
  displayName: string;
  id: string;
  emailAddress: string;
}
